import { Modal } from "@/ui";
import { useLayoutStore } from "@/app/navigation";
import { ShortcutList } from "@/features/settings/SettingsPage";

export function ShortcutsModal() {
  const open = useLayoutStore((st) => st.shortcutsOpen);
  const setOpen = useLayoutStore((st) => st.setShortcutsOpen);
  return (
    <Modal open={open} onClose={() => setOpen(false)} title="Keyboard shortcuts" size="lg">
      <ShortcutList />
      <div className="u-small u-muted" style={{ marginTop: 12 }}>Single-key shortcuts act on the focused person: the selected row, the open page, or the sidebar preview.</div>
    </Modal>
  );
}
